<template>
  <div class="withdraw-record">
    <div class="withdraw-record-header">
      <div class="withdraw-record-filters">
        <div class="withdraw-record-filter" @click="toggleDateDropdown">
          <span>{{ dateFilterText }}</span>
          <van-icon :name="showDateDropdown ? 'arrow-up' : 'arrow-down'" size="12" />
        </div>
        <div class="withdraw-record-filter" @click="toggleStatusDropdown">
          <span>{{ statusFilterText }}</span>
          <van-icon :name="showStatusDropdown ? 'arrow-up' : 'arrow-down'" size="12" />
        </div>
      </div>
      <div class="withdraw-record-total">
        <div class="withdraw-record-total-label">累计提现</div>
        <div class="withdraw-record-total-amount">
          ¥{{ totalAmount }}
          <img class="withdraw-record-total-refresh" src="/static/image/iconRefresh.png" @click="refreshData" />
        </div>
      </div>

      <!-- 日期下拉 -->
      <div class="withdraw-date-dropdown" v-if="showDateDropdown">
      <div class="withdraw-date-options">
        <div class="withdraw-date-option" :class="{ active: dateFilter === 'today' }" @click="selectDateFilter('today')">今日</div>
        <div class="withdraw-date-option" :class="{ active: dateFilter === 'yesterday' }" @click="selectDateFilter('yesterday')">昨日</div>
        <div class="withdraw-date-option" :class="{ active: dateFilter === 'all' }" @click="selectDateFilter('all')">全部</div>
      </div>
      <template v-if="dateFilter !== 'all'">
      <div class="withdraw-date-custom-label">自定义</div>
      <div class="withdraw-date-range">
        <div class="withdraw-date-range-col">
          <div class="withdraw-date-range-title">开始日期</div>
          <div class="withdraw-date-picker">
            <div class="withdraw-date-picker-col">
              <ul class="withdraw-date-picker-list" :style="{ transform: startYearTransform }">
                <li class="withdraw-date-picker-item" :class="getItemClass(startDate[0], y, yearList)" v-for="y in startYearWindow" :key="'sy'+y" @click="selectStartDate(0, y)">{{ y }}</li>
              </ul>
            </div>
            <div class="withdraw-date-picker-col">
              <ul class="withdraw-date-picker-list" :style="{ transform: startMonthTransform }">
                <li class="withdraw-date-picker-item" :class="getItemClass(startDate[1], m, monthList)" v-for="m in startMonthWindow" :key="'sm'+m" @click="selectStartDate(1, m)">{{ String(m).padStart(2, '0') }}</li>
              </ul>
            </div>
            <div class="withdraw-date-picker-col">
              <ul class="withdraw-date-picker-list" :style="{ transform: startDayTransform }">
                <li class="withdraw-date-picker-item" :class="getItemClass(startDate[2], d, dayList)" v-for="d in startDayWindow" :key="'sd'+d" @click="selectStartDate(2, d)">{{ String(d).padStart(2, '0') }}</li>
              </ul>
            </div>
            <div class="withdraw-date-picker-mask"></div>
            <div class="withdraw-date-picker-frame"></div>
          </div>
        </div>
        <div class="withdraw-date-range-col">
          <div class="withdraw-date-range-title">结束日期</div>
          <div class="withdraw-date-picker">
            <div class="withdraw-date-picker-col">
              <ul class="withdraw-date-picker-list" :style="{ transform: endYearTransform }">
                <li class="withdraw-date-picker-item" :class="getItemClass(endDate[0], y, yearList)" v-for="y in endYearWindow" :key="'ey'+y" @click="selectEndDate(0, y)">{{ y }}</li>
              </ul>
            </div>
            <div class="withdraw-date-picker-col">
              <ul class="withdraw-date-picker-list" :style="{ transform: endMonthTransform }">
                <li class="withdraw-date-picker-item" :class="getItemClass(endDate[1], m, monthList)" v-for="m in endMonthWindow" :key="'em'+m" @click="selectEndDate(1, m)">{{ String(m).padStart(2, '0') }}</li>
              </ul>
            </div>
            <div class="withdraw-date-picker-col">
              <ul class="withdraw-date-picker-list" :style="{ transform: endDayTransform }">
                <li class="withdraw-date-picker-item" :class="getItemClass(endDate[2], d, dayList)" v-for="d in endDayWindow" :key="'ed'+d" @click="selectEndDate(2, d)">{{ String(d).padStart(2, '0') }}</li>
              </ul>
            </div>
            <div class="withdraw-date-picker-mask"></div>
            <div class="withdraw-date-picker-frame"></div>
          </div>
        </div>
      </div>
      <div class="withdraw-date-btns">
        <div class="withdraw-date-btn withdraw-date-btn-cancel" @click="showDateDropdown = false">取消</div>
        <div class="withdraw-date-btn withdraw-date-btn-confirm" @click="confirmDate">确认</div>
      </div>
      </template>
      </div>

      <!-- 状态下拉 -->
      <div class="withdraw-status-dropdown" v-if="showStatusDropdown">
        <div class="withdraw-status-option" :class="{ active: statusFilter === '' }" @click="selectStatus('')">全部状态</div>
        <div class="withdraw-status-option" :class="{ active: statusFilter === '1' }" @click="selectStatus('1')">确认中</div>
        <div class="withdraw-status-option" :class="{ active: statusFilter === '2' }" @click="selectStatus('2')">等待付款</div>
        <div class="withdraw-status-option" :class="{ active: statusFilter === '3' }" @click="selectStatus('3')">提现超时</div>
        <div class="withdraw-status-option" :class="{ active: statusFilter === '4' }" @click="selectStatus('4')">提现失败</div>
        <div class="withdraw-status-option" :class="{ active: statusFilter === '5' }" @click="selectStatus('5')">提现取消</div>
        <div class="withdraw-status-option" :class="{ active: statusFilter === '6' }" @click="selectStatus('6')">提现成功</div>
      </div>
    </div>

    <!-- 提现记录列表 -->
    <div class="detail-list" v-if="recordList.length > 0">
      <div class="detail-item" v-for="(item, idx) in recordList" :key="idx">
        <div class="detail-item-left">
          <div class="detail-order-row">
            <span class="detail-order">{{ item.order_no }}</span>
          </div>
          <div class="detail-info-row">
            <span class="detail-api">{{ item.pay_way_name }}</span>
            <span class="detail-type">提现</span>
          </div>
          <div class="detail-time-row">
            <span class="detail-time">{{ item.created_at }}</span>
          </div>
        </div>
        <div class="detail-item-right">
          <span class="detail-money red">-{{ item.amount }}</span>
          <span class="detail-state">{{ item.state_name }}</span>
        </div>
      </div>

      <!-- 加载更多 -->
      <div class="load-more" v-if="recordPage < recordLastPage" @click="loadMore">
        <span>加载更多</span>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-state" v-else>
      <img src="/static/image/img_none_sj.avif" class="empty-icon" />
      <p class="empty-text">今日暂无记录，<span class="empty-more">查看更多</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawRecord',
  data() {
    return {
      dateFilter: 'all',
      statusFilter: '',
      showDateDropdown: false,
      showStatusDropdown: false,
      startDate: [2026, 7, 16],
      endDate: [2026, 7, 16],
      totalAmount: '0.00',
      recordList: [],
      recordPage: 1,
      recordLastPage: 1,
      recordLoading: false,
      itemHeight: 0.6,
    };
  },
  computed: {
    dateFilterText() {
      if (this.dateFilter === 'custom') {
        const s = `${this.startDate[0]}-${String(this.startDate[1]).padStart(2, '0')}-${String(this.startDate[2]).padStart(2, '0')}`;
        const e = `${this.endDate[0]}-${String(this.endDate[1]).padStart(2, '0')}-${String(this.endDate[2]).padStart(2, '0')}`;
        return `${s} ~ ${e}`;
      }
      const map = { today: '今日', yesterday: '昨日', all: '全部' };
      return map[this.dateFilter] || '今日';
    },
    statusFilterText() {
      const map = { '': '全部状态', '1': '确认中', '2': '等待付款', '3': '提现超时', '4': '提现失败', '5': '提现取消', '6': '提现成功' };
      return map[this.statusFilter] || '全部状态';
    },
    yearList() {
      const now = new Date().getFullYear();
      const list = [];
      for (let y = now - 5; y <= now + 5; y++) list.push(y);
      return list;
    },
    endYearList() {
      const now = new Date();
      const list = [];
      for (let y = now.getFullYear() - 5; y <= now.getFullYear(); y++) list.push(y);
      return list;
    },
    monthList() {
      return Array.from({ length: 12 }, (_, i) => i + 1);
    },
    endMonthList() {
      const now = new Date();
      if (this.endDate[0] < now.getFullYear()) {
        return Array.from({ length: 12 }, (_, i) => i + 1);
      }
      return Array.from({ length: now.getMonth() + 1 }, (_, i) => i + 1);
    },
    dayList() {
      return Array.from({ length: 31 }, (_, i) => i + 1);
    },
    endDayList() {
      const now = new Date();
      if (this.endDate[0] < now.getFullYear() || this.endDate[1] < now.getMonth() + 1) {
        return Array.from({ length: 31 }, (_, i) => i + 1);
      }
      return Array.from({ length: now.getDate() }, (_, i) => i + 1);
    },
    startYearWindow() { return this.getWindow(this.yearList, this.startDate[0]); },
    startMonthWindow() { return this.getWindow(this.monthList, this.startDate[1]); },
    startDayWindow() { return this.getWindow(this.dayList, this.startDate[2]); },
    endYearWindow() { return this.getWindow(this.endYearList, this.endDate[0]); },
    endMonthWindow() { return this.getWindow(this.endMonthList, this.endDate[1]); },
    endDayWindow() { return this.getWindow(this.endDayList, this.endDate[2]); },
    startYearTransform() { return this.computeWindowTransform(this.startYearWindow, this.startDate[0]); },
    startMonthTransform() { return this.computeWindowTransform(this.startMonthWindow, this.startDate[1]); },
    startDayTransform() { return this.computeWindowTransform(this.startDayWindow, this.startDate[2]); },
    endYearTransform() { return this.computeWindowTransform(this.endYearWindow, this.endDate[0], this.endYearList); },
    endMonthTransform() { return this.computeWindowTransform(this.endMonthWindow, this.endDate[1], this.endMonthList); },
    endDayTransform() { return this.computeWindowTransform(this.endDayWindow, this.endDate[2], this.endDayList); },
  },
  mounted() {
    this.fetchRecords();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getWindow(list, selectedVal) {
      const idx = list.indexOf(selectedVal);
      const items = [];
      if (idx > 0) items.push(list[idx - 1]);
      items.push(selectedVal);
      if (idx < list.length - 1) items.push(list[idx + 1]);
      return items;
    },
    computeWindowTransform(window, selectedVal, list) {
      const idx = window.indexOf(selectedVal);
      const offset = 0.9 - idx * this.itemHeight;
      return `translateY(${offset}rem)`;
    },
    selectDateFilter(filter) {
      this.dateFilter = filter;
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      if (filter === 'today') {
        this.startDate = [year, month, day];
        this.endDate = [year, month, day];
      } else if (filter === 'yesterday') {
        const y = new Date(now.getTime() - 86400000);
        this.startDate = [y.getFullYear(), y.getMonth() + 1, y.getDate()];
        this.endDate = [y.getFullYear(), y.getMonth() + 1, y.getDate()];
      }
      if (filter === 'all') {
        this.showDateDropdown = false;
      }
      this.fetchRecords();
    },
    selectStatus(val) {
      this.statusFilter = val;
      this.showStatusDropdown = false;
      this.recordPage = 1;
      this.fetchRecords();
    },
    toggleDateDropdown() {
      this.showDateDropdown = !this.showDateDropdown;
      if (this.showDateDropdown) {
        this.showStatusDropdown = false;
      }
    },
    toggleStatusDropdown() {
      this.showStatusDropdown = !this.showStatusDropdown;
      if (this.showStatusDropdown) {
        this.showDateDropdown = false;
      }
    },
    confirmDate() {
      this.dateFilter = 'custom';
      this.showDateDropdown = false;
      this.recordPage = 1;
      this.fetchRecords();
    },
    selectStartDate(idx, val) {
      this.$set(this.startDate, idx, val);
    },
    selectEndDate(idx, val) {
      this.$set(this.endDate, idx, val);
    },
    getItemClass(selectedVal, val, list) {
      if (val === selectedVal) return 'selected';
      return '';
    },
    refreshData() {
      this.recordPage = 1;
      this.fetchRecords();
    },
    handleScroll() {
      if (this.recordLoading || this.recordPage >= this.recordLastPage) return;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;
      if (scrollTop + windowHeight >= pageHeight - 100) {
        this.loadMore();
      }
    },
    loadMore() {
      this.recordPage++;
      this.fetchRecords(true);
    },
    fetchRecords(loadMore) {
      const that = this;
      if (!loadMore) that.showLoading();
      that.recordLoading = true;

      let startDate = '';
      let endDate = '';
      if (that.dateFilter === 'custom') {
        startDate = `${that.startDate[0]}-${String(that.startDate[1]).padStart(2, '0')}-${String(that.startDate[2]).padStart(2, '0')}`;
        endDate = `${that.endDate[0]}-${String(that.endDate[1]).padStart(2, '0')}-${String(that.endDate[2]).padStart(2, '0')}`;
      }

      const postData = {
        date_type: that.dateFilter || 'all',
        status: that.statusFilter || '',
        start_date: startDate || '',
        end_date: endDate || '',
        page: that.recordPage || 1,
        page_size: 10,
      };

      that.$apiFun
        .post('/api/withdraw_record_new', postData)
        .then(res => {
          that.hideLoading();
          that.recordLoading = false;
          if (res.code === 200) {
            if (loadMore) {
              that.recordList = that.recordList.concat(res.data.data || []);
            } else {
              that.recordList = res.data.data || [];
            }
            that.recordLastPage = res.data.last_page || 1;
            that.totalAmount = res.data.total_amount || '0.00';
          }
        })
        .catch(err => {
          that.hideLoading();
          that.recordLoading = false;
          console.error('withdraw_record_new error:', err);
        });
    },
    showLoading() {
      if (this.$root.showLoading) this.$root.showLoading();
    },
    hideLoading() {
      if (this.$root.hideLoading) this.$root.hideLoading();
    },
  },
};
</script>

<style lang="scss" scoped>
.withdraw-record {
  padding: 0.2rem;
}

.withdraw-record-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.2rem;
  position: relative;
  z-index: 10;
}

.withdraw-record-filters {
  display: flex;
  gap: 0.15rem;
}

.withdraw-record-filter {
  display: flex;
  align-items: center;
  gap: 0.05rem;
  padding: 0.1rem 0.2rem;
  border: 1px solid #555;
  border-radius: 0.3rem;
  font-size: 0.3rem;
  color: #ccc;
  cursor: pointer;
}

.withdraw-record-total {
  text-align: right;
}

.withdraw-record-total-label {
  font-size: 0.3rem;
  color: #999;
  margin-bottom: 0.05rem;
}

.withdraw-record-total-amount {
  font-size: 0.3rem;
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.05rem;

  .withdraw-record-total-refresh {
    width: 0.25rem;
    height: 0.25rem;
    cursor: pointer;
  }
}

.withdraw-date-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #222;
  border-radius: 0.15rem;
  padding: 0.3rem;
  z-index: 100;
}

.withdraw-date-options {
  display: flex;
  margin-bottom: 0.2rem;
}

.withdraw-date-option {
  width: 30%;
  text-align: center;
  padding: 0.25rem 0;
  border: 1px solid #555;
  border-radius: 0.1rem;
  font-size: 0.32rem;
  color: #fff;
  cursor: pointer;

  &.active {
    border-color: #DFB372;
    color: #DFB372;
  }
}

.withdraw-date-custom-label {
  font-size: 0.3rem;
  color: #fff;
  margin-bottom: 0.15rem;
}

.withdraw-date-range {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.2rem;
}

.withdraw-date-range-col {
  flex: 1;
}

.withdraw-date-range-title {
  text-align: center;
  font-size: 0.35rem;
  color: #999;
  margin-bottom: 0.1rem;
}

.withdraw-date-picker {
  display: flex;
  height: 2.4rem;
  position: relative;
  overflow: hidden;
}

.withdraw-date-picker-col {
  flex: 1;
  position: relative;
  height: 100%;
}

.withdraw-date-picker-list {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  transition: transform 0.3s ease;
}

.withdraw-date-picker-item {
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.26rem;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;

  &.selected {
    color: #fff;
    font-size: 0.35rem;
    font-weight: bold;
  }
}

.withdraw-date-picker-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(34, 34, 34, 0.9) 0%,
    rgba(34, 34, 34, 0) 35%,
    rgba(34, 34, 34, 0) 65%,
    rgba(34, 34, 34, 0.9) 100%
  );
}

.withdraw-date-picker-frame {
  position: absolute;
  top: 0.9rem;
  left: 0;
  right: 0;
  height: 0.6rem;
  pointer-events: none;
  border-top: 1px solid #444;
  border-bottom: 1px solid #444;
}

.withdraw-date-btns {
  display: flex;
  gap: 0.2rem;
}

.withdraw-date-btn {
  flex: 1;
  text-align: center;
  padding: 0.25rem 0;
  border-radius: 0.1rem;
  font-size: 0.35rem;
  cursor: pointer;
}

.withdraw-date-btn-cancel {
  border: 1px solid #DFB372;
  color: #DFB372;
}

.withdraw-date-btn-confirm {
  background: #DFB372;
  color: #1a1a1a;
}

.withdraw-status-dropdown {
  position: absolute;
  top: 100%;
  left: 1.6rem;
  width: 3rem;
  background: #222;
  border-radius: 0.15rem;
  padding: 0.1rem 0;
  z-index: 100;
  max-height: 3rem;
  overflow-y: auto;
}

.withdraw-status-option {
  padding: 0.2rem 0.3rem;
  font-size: 0.35rem;
  color: #999;
  cursor: pointer;

  &.active {
    color: #DFB372;
  }
}

/* 明细列表（与report页面一致） */
.detail-list {
  padding: 0;
  margin-bottom: 2rem;

  .detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #222;
    padding: 0.2rem 0.3rem;
    margin-bottom: 0.2rem;
    border-bottom: none;

    .detail-item-left {
      display: flex;
      flex-direction: column;
      gap: 0.15rem;

      .detail-order-row {
        .detail-order {
          padding: 0.2rem 0;
          font-size: .35rem;
          color: #999;
          letter-spacing: 0.02rem;
        }
      }

      .detail-info-row {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        letter-spacing: 0.05rem;

        .detail-api {
          font-size: 0.28rem;
          color: #d1ae52;
          background: rgba(209, 174, 82, 0.15);
          padding: 0.03rem 0.12rem;
          border-radius: 0.04rem;
        }

        .detail-type {
          font-size: 0.28rem;
          color: #fff;
        }
      }

      .detail-time-row {
        .detail-time {
          font-size: 0.24rem;
          color: #666;
          letter-spacing: 0.03rem;
        }
      }
    }

    .detail-item-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 0.08rem;

      .detail-money {
        font-size: 0.32rem;
        font-weight: bold;

        &.green {
          color: #3c3;
        }

        &.red {
          color: #ff6034;
        }
      }

      .detail-state {
        font-size: 0.28rem;
        color: #999;
      }
    }
  }
}

/* 加载更多 */
.load-more {
  text-align: center;
  padding: 0.2rem 0;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  color: #d1ae52;
  cursor: pointer;
}

/* 空状态（与report页面一致） */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3rem 0;
  color: #666;

  .empty-icon {
    width: 3rem;
    height: 3rem;
    margin-bottom: 0.2rem;
  }

  .empty-text {
    font-size: 0.35rem;
    color: #666;

    .empty-more {
      color: #d1ae52;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/withdraw/WithdrawRecord.vue